import {Box, Grid} from "@mui/material";

import FilteredDataGrid from "./FilteredDataGrid";
import ModalTrigger from "../Common/ModalTrigger";
import CustomLink from "../Common/CustomLink";
import csv4 from "../../Data/MANCP/Pesticides/MANCP-Results-on-import-control-samples-under-Regulation-2019-1793.csv";

const ImportControl = (props) => {
  return (
    <Grid
      item
      container
      direction={ {xs: "column", sm: "column", md: "row"} }
      sx={ {
        marginTop: {xs: "50px", sm: "50px", md: "90px"},
        marginBottom: {xs: "50px", sm: "50px", md: "90px"},
      } }
    >
      <Grid
        item
        xs
        p={ 3 }
        className="five-one"
        sx={ {maxWidth: {md: "450px !important"}} }
      >
        <Box
          sx={ {
            textAlign: {xs: "left", sm: "center", md: "left"},
          } }
        >
          <h3>Results for import control samples</h3>
          <p className="paragraph">
            Under the provisions of{ " " }
            <CustomLink
              text="Regulation (EU) 2019/1793"
              href="https://eur-lex.europa.eu/eli/reg_impl/2019/1793/oj"
            />{ " " }
            on import controls, certain foods were subject to an increased frequency of official controls for certain pesticides at the point of entry into the EU. The data presented in this section is a subset of those sent by reporting countries to the{ " " }
            <CustomLink
              text="TRACES"
              href="https://webgate.ec.europa.eu/IMSOC/tracesnt-help/Content/en/index.html#UUID-f90f8998-21c0-6b73-42fc-003c5cbba3fa_section-idm4622757130648033607355662827"
            />{ " " }
            online monitoring tool through the Integrated Management System for Official Controls (IMSOC) platform. More information on the overall number of samples generating RASFF notifications can be found in <CustomLink
            text="the 2023 Rapid Alert System for Food and Feed (RASFF) report"
            href="https://food.ec.europa.eu/document/download/911d49f2-b3ef-4752-8ea3-5f20dbbe9945_en?filename=acn_annual-report_2023.pdf"
          />
            .
          </p>
          <p className="paragraph">
            In total, 28,393 samples were reported to EFSA and presented in the report. Of those, 725 samples (2.6%) were considered non-compliant. The 2023 revisions of this Regulation included <ModalTrigger
            style={ {
              color: "#22294D",
              cursor: "pointer",
              borderBottom: "1px dotted",
            } }
            text="composite food products"
          /> and feed.
          </p>
          {/* <p className="paragraph">
           The 2022 revisions of this regulation included{" "}
           <ModalTrigger
           style={{
           color: "#22294D",
           cursor: "pointer",
           borderBottom: "1px dotted",
           }}
           text="composite food products"
           />{". "}
           This type of food is not in the scope of this report as the
           applicable MRL depends on the specific ingredients that are part of
           the products, and on their proportion within the product. However,
           an ad-hoc analysis was done of the 169 composite food samples
           reported to EFSA. Of those, 2 samples (1.2%) led to non-compliance
           for ethylene oxide in ‘Asian-style noodles other than glass noodles’
           and ‘food supplements and similar preparations’ respectively.
           </p> */ }
        </Box>
      </Grid>
      <Grid
        item
        xs
        p={ 3 }
        className="five-two"
        sx={ {maxWidth: "200px !important"} }
      >
        <FilteredDataGrid csv={ csv4 }/>
      </Grid>
    </Grid>
  );
};

export default ImportControl;
